import { GET_BOOKING_ANALYTICS, GET_BOOKING_ANALYTICS_SUCCESS, GET_BOOKING_ANALYTICS_ERROR, GET_BOOKING_ANALYTICS_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetBookingsAnalytics = (state = initialState, action) => {
  switch (action.type) {
    case GET_BOOKING_ANALYTICS:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_BOOKING_ANALYTICS_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_BOOKING_ANALYTICS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_BOOKING_ANALYTICS_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetBookingsAnalytics;
